import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import ConsumedEventView from './consumedEventView';

type Props = {
  consumedEvents: any[];
  maxHeight?: number;
};

const ConsumedEventsView = ({ consumedEvents = [] }: Props) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      <Box sx={{ mb: 1 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          Consumed Events
        </Typography>
      </Box>
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', width: '23%', fontWeight: 700 }}>
                  Entity Type
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', width: '23%', fontWeight: 700 }}>
                  Entity Def
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', width: '23%', fontWeight: 700 }}>
                  Entity
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', width: '23%', fontWeight: 700 }}>
                  Event
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(consumedEvents || []).map((consumedEvent: any, idx: any) => {
                return <ConsumedEventView key={idx} consumedEvent={consumedEvent} />;
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default ConsumedEventsView;
